export var ResourceType;
(function (ResourceType) {
    ResourceType["RESOURCE"] = "RESOURCE";
    ResourceType["ATTRIBUTE"] = "ATTRIBUTE";
})(ResourceType || (ResourceType = {}));
